import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const digitalhealth = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
